// /demo/fresh — always starts a brand-new demo session and auto-opens the tour.
//
// Wipes any prior per-browser state (session, user, tour progress, UI
// dismissals) and does a full-page reload to "/?autotour=1", which is
// consumed by TourProvider to launch Stop 0 automatically. This is the URL
// intended for sharing with testers and investors.

import { useEffect } from "react";

export default function DemoFresh() {
  useEffect(() => {
    try {
      localStorage.removeItem("commons.session.v1");
      localStorage.removeItem("commons.user.v1");
      localStorage.removeItem("commons.tour.v1");
      sessionStorage.clear();
    } catch (_) { /* ignore */ }
    // Full reload so CommonsProvider re-runs auto-provisioning from scratch.
    window.location.replace("/?autotour=1");
  }, []);

  return (
    <div className="c-load" data-testid="demo-fresh-loading">
      Opening a fresh Commons…
    </div>
  );
}
